import { isNullOrWhiteSpace } from 'Util/Helpers/Validation';

export interface RegistrationType {
   registrationTypeCode: string;
   description: string;
   cblcredits: string;
   disciplineCode: string;
   registrationTypeCodeNew: string;
}

type RegistrationTypeReadonly = Readonly<RegistrationType>;

export default RegistrationTypeReadonly;

export const DefaultRegistrationTypeModel: RegistrationType = {
   registrationTypeCode: '',
   description: '',
   cblcredits: '',
   disciplineCode: '',
   registrationTypeCodeNew: '',
};

interface ValidationModel {
   registrationTypeCode: boolean;
   description: boolean;
   disciplineCode: boolean;
}

export type RegistrationTypeValidation = Readonly<ValidationModel>;

export const validateRegistrationType = (
   registrationType: RegistrationType
): RegistrationTypeValidation => {
   return {
      registrationTypeCode:
         !isNullOrWhiteSpace(registrationType.registrationTypeCode) &&
         registrationType.registrationTypeCode.length <= 4,
      description: !isNullOrWhiteSpace(registrationType.description),
      disciplineCode: !isNullOrWhiteSpace(registrationType.disciplineCode),
   };
};
